import React from 'react';
import { Table3DataContext } from '~/app/shared/table3tools/contexts/Table3DataContext';
import usePaginatedDataFetcher from '~/app/shared/table3tools/hooks/usePaginatedDataFetcher';
import useTable3DataContextLoader from '~/app/shared/table3tools/hooks/useTable3DataContextLoader';
import { ProductListView } from '~/types/internal-api';

export default function useProductsViewTable3DataContextLoader(): Table3DataContext<ProductListView> {
    const paramFactory = React.useCallback(() => `filter=isAccessible$eq:true`, []);
    const fetcher = usePaginatedDataFetcher<ProductListView>('/products', paramFactory);
    const context = useTable3DataContextLoader(fetcher);
    return context;
}
